import { useState } from 'react';
import { Route, Switch, Link } from 'react-router-dom';
import Photos from './photos/Photos';
import About from './about/About';
import Contact from './contact/Contact';
import './App.css';

function App() {
  const handleChange = () => {
  }
  return (
    <div style={{ margin: "2rem" }}>
      <div>
        <div id="nav">
          <span id="left-nav"><Link to="/">Leyang Yu</Link></span>
          <span id="right-nav">
            <Link to="/about"> About</Link> |
            <Link to="/contact"> Contact</Link>
            {/* | World Map |
            Running */}
          </span>
        </div>
      </div><br />
      <Switch>
        <Route exact path="/" render={() => (
          <Photos />
        )} />
        <Route exact path="/photos" render={() => (
          <Photos />
        )} />
        <Route exact path="/photos/:country" render={(props) => (
          <Photos country={props.match.params.country} />
        )} />
        <Route exact path="/about" render={() => (
          <About />
        )} />
        <Route exact path="/contact" render={() => (
          <Contact />
        )} />
      </Switch>
    </div>
  );
}

export default App;
